import IconInfo from '@apollo/icons/default/IconInfo.svg';
import React from 'react';

import { ClickableText } from 'src/components/common/clickableText/ClickableText';
import Config from 'src/lib/config';

export const CollectionsFeedbackCallout = () => (
  <div className="flex items-center truncate text-sm text-inverted">
    <IconInfo className="mr-2 text-placeholder" />
    <span className="w-full truncate">
      We recently added Operation Collections to Explorer. We would{' '}
      <ClickableText
        as="a"
        target="_blank"
        className="text-link no-underline hover:no-underline"
        rel="noopener noreferrer"
        href={`https://docs.google.com/forms/d/e/1FAIpQLSerYkQkDN-3M5UUWH7M10DyjVLxoULVZy-pVpt1iaEA0NaSug/viewform?${
          Config.gitCommitHash
            ? // Prefill the git hash if there is one, 691752175 is the question id
              `usp=pp_url&entry.691752175=${Config.gitCommitHash}`
            : 'usp=send_form'
        }`}
      >
        love your feedback. 👂
      </ClickableText>
    </span>
  </div>
);
